const imgMixin = {
	methods: {
		webp: function(url) {
			if(url) {
				url=url.replace(/@!w4/,'');
				//url = url.replace(/__.webp/, '');
			}
			return url;
		}
	}
};

export default imgMixin


// WEBPACK FOOTER //
// ./src/mixins/image.js